export default __webpack_public_path__ + "static/media/event-5.65f72215.jpg";